<input
  [ngClass]="{ small: small === true }"
  [type]="type"
  [placeholder]="placeholder"
  class="quantum-input"
  (keyup)="onKey($event)"
/>
